<template>
  <div class="page404Container">
    <div class="message404">
      <h1>OH NO! 404</h1>
      <p><b>THE LINK YOU FOLLOWED IS PROBABLY</b></p>
      <p><b>BROKEN OR THE PAGE HAS BEEN REMOVED.</b></p>
      <p style="height:15px"></p>
      <v-btn large outlined color="#34417c" @click="goHome">
        Go to home
      </v-btn>
    </div>
    <div>
      <img
        class="imageCentered"
        :src="require('@/assets/img/connectionFail.png')"
      >
    </div>
  </div>
</template>

<style></style>

<script>
import * as Sentry from '@sentry/vue'
export default {
  name: 'page404',
  methods: {
    goHome: function () {
      this.$router.push({ name: 'Homepage' }).catch(error => {
        Sentry.captureException(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/404.vue